var map = {
	"./f-audio.png": "ef1f",
	"./f-bmp.png": "de25",
	"./f-doc.png": "5d4d",
	"./f-docx.png": "50b9",
	"./f-gif.png": "df85",
	"./f-jpeg.png": "c5f8",
	"./f-jpg.png": "5ca7",
	"./f-mp3.png": "4632",
	"./f-mp4.png": "1f78",
	"./f-other.png": "ffef",
	"./f-pdf.png": "e394",
	"./f-png.png": "3282",
	"./f-ppt.png": "4a08",
	"./f-pptx.png": "3c59",
	"./f-rar.png": "d555",
	"./f-txt.png": "0e1b",
	"./f-xls.png": "36a3",
	"./f-xlsx.png": "93b2",
	"./f-zip.png": "2922"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2f9";